'use strict';

/** @type {import('.')} */
module.exports = Error;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/index.js
// module id = 85
// module chunks = 0